// src/lib/notificacoesRealtime.js
// Assinatura Realtime da tabela `notificacoes` (Supabase) — entrega em tempo real,
// sem precisar navegar. RLS continua valendo: cada usuário só recebe os próprios eventos.
// Cada superfície (topbar desktop, sino mobile) passa seu onNew p/ atualizar o badge.

import { sb } from '../api/supabaseClient.js';
import { tenant } from '../context/tenantContext.js';
import { showToast } from './toast.js';

let _channel = null;

export function iniciarNotificacoesRealtime(onNew) {
  const uid = tenant.user?.id;
  if (!uid) return;
  pararNotificacoesRealtime();
  _channel = sb.channel('notif-rt-' + uid)
    .on('postgres_changes',
      { event: 'INSERT', schema: 'public', table: 'notificacoes', filter: `usuario_id=eq.${uid}` },
      (payload) => {
        const n = payload.new || {};
        try { showToast(n.titulo || 'Nova notificação', 'info'); } catch (e) {}
        try { onNew?.(n); } catch (e) {}
      })
    .subscribe();
}

export function pararNotificacoesRealtime() {
  if (_channel) { try { sb.removeChannel(_channel); } catch (e) {} _channel = null; }
}
